/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-10-27 11:24:13
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2022-11-02 16:33:13
 * @FilePath     : /ticket-plat-frontend/src/router/interceptor.ts
 */
import isMobile from 'ismobilejs';
import omit from 'lodash/omit';
import VueRouter, {Route, NavigationGuardNext} from 'vue-router';
import TicketRouterConvert from '@/router/convert/index';
import {Platform} from '@/router/convert/routerConfig';
import {postSupportTicketUrl} from '@/utils/supportMessage';
// import store from '@/store';
// import {userInfoReady} from '@/store/userInfoReady';

// 同步执行，如方法为异步方法，方法内数据不要互相依赖
const interceptors = {
    before: [
        // 若用户拥有 createRapid 特性，访问 /ticket/create 时重定向到 /ticket/create_rapid
        async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
            if (to.path === '/ticket/create') {
                // await userInfoReady;
                // const features: string[] = store.getters.userInfo?.features || [];
                // console.log(features);
                // if (features.includes('rapidCreate')) {
                return next({path: '/ticket/create_rapid', query: to.query, replace: true});
                // }
            }
            next();
        },
        // /path~paramA=valueA 转换为 /path?paramA=valueA
        // 默认特殊情景, 不做适配检查
        // 1. path 中一定不含有 ~
        // 2. param name中一定不含有 ~ 和 =
        // 3. value 中可能含有 ~, 但没有 =
        (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
            let href = location.href;
            if (location.href !== unescape(location.href)) {
                // url 中已经包含转义后字符的
                setTimeout(() => location.replace(unescape(href))); // 不使用 setTimeout, 有时候不生效
                next();
            }

            const separatorIndex = to.path.indexOf('~');
            const equalSignIndex = to.path.indexOf('=');
            if (separatorIndex < equalSignIndex) {
                // 不使用 setTimeout, 有时候不生效
                setTimeout(() => location.replace(href.replace(to.path, to.path.replace('~', '?'))));
                next();
            }

            // 屏幕尺寸小于ipad尺寸时跳转app页面
            setTimeout(() => {
                if (isMobile(navigator.userAgent).phone) {
                    const convert = new TicketRouterConvert();
                    convert.setPathWhitelist([ // 白名单内的路径才转发
                        '',
                        '#/',
                        '#/ticket/create',
                        '#/ticket/list',
                    ]);
                    const mobileUrl = convert.formatToString({
                        // 不可使用上面的变量 href，因 location.href 的变化要慢于 to 的变化
                        // 所以 href 的值其实还是上个页面的路径值
                        // 通过 settimeout 重新获取 location.href 可获取到最新的值
                        router: location.href,
                        from: Platform.Pc,
                        to: Platform.Mobile,
                    });
                    mobileUrl && setTimeout(() => location.replace(mobileUrl)); // 不使用 setTimeout, 有时候不生效
                }
            }, 0);
            next();
        },
    ],
    after: [
        (to: Route, from: Route, router: VueRouter) => {
            let query = to.query;
            if (query.site) {
                query = omit(query, 'site');
                router.replace({
                    path: to.path,
                    query,
                });
            }
            if (window.isSupportIframe) {
                postSupportTicketUrl(to.path, query);
            }
        },
    ],
};

export default (router: VueRouter) => {
    router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
        for (const interceptor of interceptors.before) {
            let redirected = false;
            const wrappedNext: NavigationGuardNext<Vue> = (...args: any[]) => {
                if (args.length > 0 && args[0] !== undefined) {
                    redirected = true;
                }
                (next as any)(...args);
            };
            await interceptor(to, from, wrappedNext);
            if (redirected) {
                return;
            }
        }
    });

    router.afterEach((to: Route, from: Route) => {
        interceptors.after.forEach(
            (interceptor: (to: Route, from: Route, router: VueRouter) => void) => interceptor(to, from, router)
        );
    });
};
